module.exports = __webpack_public_path__ + "media/images/icons/info-96f34ccaa3b31701f4f68814b437fefe.svg";